<template>
  <div id="contenedor-contratos-configuracion-firmas">
    Firmas
  </div>
</template>

<script>
export default {
  name: 'ContratosConfiguracionFirmas',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
